import {sequenceCardSchema} from '../../../../../schemas/sequenceCardSchema';
import {z} from 'zod';
import {NodeType, OutputType} from 'common/src/modules/nodes/nodes.types';
import {
  DTSequenceNode,
  SequenceNodeOutputData,
} from 'common/src/modules/decisionTree/decisionTree.types';
import {NO_NODE_ID} from 'common/src/components/CLCardsMap/CLCardsMap.config';
import {getAICardBaseDetails} from '../../utils/getAICardBaseDetails';

const LAST_OUTPUT_NAME = 'Last output';
const FALLBACK_OUTPUT_NAME = 'Fallback';

export function convertSequenceAICardToAPICard(
  sequenceCard: z.input<typeof sequenceCardSchema>,
  existingCard: DTSequenceNode,
) {
  //For each of the repeats, add an output, not connected.
  //Connecting the outputs will be done later.

  const outputs: SequenceNodeOutputData[] = sequenceCard.repeats.map((repeat, index) => ({
    nodeId: existingCard?.outputs?.[index]?.nodeId ?? NO_NODE_ID,
    id: index + 1,
    name: repeat.name,
    maxRepeats: repeat.timesToRepeat,
    type: OutputType.Regular,
  }));

  if (
    sequenceCard.numberOfTimesToRepeat &&
    !outputs.some((output) => output.name === LAST_OUTPUT_NAME || output.type === OutputType.Last)
  ) {
    outputs.push({
      id: outputs.length + 1,
      name: LAST_OUTPUT_NAME,
      type: OutputType.Last,
      nodeId: NO_NODE_ID,
    });
  }

  if (
    !outputs.some(
      (output) => output.name === FALLBACK_OUTPUT_NAME || output.type === OutputType.Fallback,
    )
  ) {
    outputs.push({
      id: outputs.length + 1,
      name: FALLBACK_OUTPUT_NAME,
      type: OutputType.Fallback,
      nodeId: NO_NODE_ID,
    });
  }

  return {
    ...getAICardBaseDetails(sequenceCard),
    ...sequenceCard,
    maxRepeats: sequenceCard.numberOfTimesToRepeat || null,
    type: NodeType.SEQUENCE,
    outputs,
    inputs: [],
  } as DTSequenceNode;
}
